import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
function EditBlog() {

  const { id } = useParams();

  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    category: "",
    description: "",
    image: "",
  });

  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);

  // FETCH BLOG
  useEffect(() => {

    fetch(
      `https://swiftintelli.com/api/get_single_blog.php?id=${id}`
    )

      .then((res) => res.json())

      .then((data) => {

        setForm(data);

        setLoading(false);

      })

      .catch((err) => {

        console.log(err);

        setLoading(false);

      });

  }, [id]);

  // HANDLE CHANGE
  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

  };

  // UPDATE BLOG
  const handleSubmit = async (e) => {

    e.preventDefault();

    setSaving(true);

    try {

      const res = await fetch(
        "https://swiftintelli.com/api/edit_blog.php",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            ...form,
            id,
          }),
        }
      );

      const data = await res.json();

      setSaving(false);

      if (data.status === "success") {

        alert("Updated ✅");

        navigate("/admin-add-blog");

      } else {

        alert("Update Failed ❌");
      }

    } catch (err) {

      console.log(err);

      setSaving(false);

      alert("Server Error ❌");
    }
  };

  return (
    <>
      <Navbar />

      <div className="eb-page">

        <div className="eb-container">

          {/* HEADER */}

          <div className="eb-header">

            <div className="eb-header-icon">

              <svg
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >

                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>

                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>

              </svg>

            </div>

            <div>

              <h1 className="eb-title">
                Edit Blog
              </h1>

              <p className="eb-subtitle">
                Update your blog post details
              </p>

            </div>

          </div>

          {/* LOADING */}

          {loading ? (

            <div className="eb-loading">

              <div className="eb-spinner" />

              Loading blog data...

            </div>

          ) : (

            /* FORM */

            <form
              className="eb-form"
              onSubmit={handleSubmit}
            >

              {/* TITLE */}

              <div className="eb-field">

                <label className="eb-label">
                  Blog Title
                </label>

                <input
                  className="eb-input"
                  type="text"
                  name="title"
                  placeholder="Enter blog title"
                  value={form.title}
                  onChange={handleChange}
                  required
                />

              </div>

              {/* CATEGORY */}

              <div className="eb-field">

                <label className="eb-label">
                  Category
                </label>

                <input
                  className="eb-input"
                  type="text"
                  name="category"
                  placeholder="e.g. Web Development"
                  value={form.category}
                  onChange={handleChange}
                  required
                />

              </div>

              {/* DESCRIPTION */}

              <div className="eb-field">

  <label className="eb-label">
    Description
  </label>

  <div className="ckeditor-wrapper">

    <CKEditor
      editor={ClassicEditor}

      disableWatchdog

      data={form.description}

      onChange={(event, editor) => {

        const data = editor.getData();

        setForm({
          ...form,
          description: data,
        });

      }}

      config={{
        placeholder: "Write blog content here...",

        toolbar: [

          "heading",

          "|",

          "bold",
          "italic",

          "|",

          "bulletedList",
          "numberedList",

          "|",

          "link",
          "blockQuote",
          "insertTable",

          "|",

          "undo",
          "redo",

        ],
      }}
    />

  </div>

</div>

              {/* IMAGE */}

              <div className="eb-field">

                <label className="eb-label">
                  Image URL
                </label>

                <input
                  className="eb-input"
                  type="text"
                  name="image"
                  placeholder="https://example.com/image.jpg"
                  value={form.image}
                  onChange={handleChange}
                  required
                />

                {/* IMAGE PREVIEW */}

                {form.image && (

                  <div className="eb-image-preview">

                    <img
                      src={form.image}
                      alt="Preview"
                    />

                  </div>

                )}

              </div>

              {/* ACTIONS */}

              <div className="eb-actions">

                <button
                  type="button"
                  className="eb-btn eb-btn--secondary"
                  onClick={() =>
                    navigate("/admin-add-blog")
                  }
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="eb-btn eb-btn--primary"
                  disabled={saving}
                >

                  {saving && (
                    <span className="eb-btn-spinner" />
                  )}

                  {saving
                    ? "Saving..."
                    : "Update Blog"}

                </button>

              </div>

            </form>

          )}

        </div>

      </div>
    </>
  );
}

export default EditBlog;